const AnalysisAdd = () => {
  return (
    <div className=" w-full flex justify-around ">
      <div className=" flex flex-col justify-center items-center space-y-4">
        <div>Blunder</div>
        <div className=" bg-[#e14545] px-4 py-2 rounded-lg text-white font-bold">
          1
        </div>
      </div>
      <div className=" flex flex-col justify-center items-center space-y-4">
        <div>Mistake</div>
        <div className=" bg-[#f6a936] px-4 py-2 rounded-lg text-white font-bold">
          3
        </div>
      </div>
      <div className=" flex flex-col justify-center items-center space-y-4">
        <div>Good</div>
        <div className=" bg-[#42e059] px-4 py-2 rounded-lg text-white font-bold">
          4
        </div>
      </div>
      <div className=" flex flex-col justify-center items-center space-y-4">
        <div>Best</div>
        <div className=" bg-[#418beb] px-4 py-2 rounded-lg text-white font-bold">
          2
        </div>
      </div>
    </div>
  );
};

export default AnalysisAdd;
